<template>
	<div>Authentication Error</div>
</template>

<script>
export default {
	name: 'OidcCallBackError'
};
</script>

<style lang="scss" scoped></style>
